export default {
  title: {
    en: 'Error',
  },
}
